type EnvironmentName = "sandbox" | "production";

interface EndpointConfig {
  apiBaseUrl: string;
  sseBaseUrl: string;
}

const DEFAULT_ENDPOINTS: Record<EnvironmentName, EndpointConfig> = {
  sandbox: {
    apiBaseUrl: "https://api.sandbox.efocs.app/api/actions",
    sseBaseUrl: "https://sse.sandbox.efocs.app/api/sse",
  },
  production: {
    apiBaseUrl: "https://api.prod.efocs.app/api/actions",
    sseBaseUrl: "https://sse.prod.efocs.app/api/sse",
  },
};

function getEnvValue(name: string, fallback: string): string {
  return process.env[name] || fallback;
}

export const endpointConfig: Record<EnvironmentName, EndpointConfig> = {
  sandbox: {
    apiBaseUrl: getEnvValue("VUE_APP_SANDBOX_API_BASE_URL", DEFAULT_ENDPOINTS.sandbox.apiBaseUrl),
    sseBaseUrl: getEnvValue("VUE_APP_SANDBOX_SSE_BASE_URL", DEFAULT_ENDPOINTS.sandbox.sseBaseUrl),
  },
  production: {
    apiBaseUrl: getEnvValue("VUE_APP_PRODUCTION_API_BASE_URL", DEFAULT_ENDPOINTS.production.apiBaseUrl),
    sseBaseUrl: getEnvValue("VUE_APP_PRODUCTION_SSE_BASE_URL", DEFAULT_ENDPOINTS.production.sseBaseUrl),
  },
};

export const pingUrl = getEnvValue("VUE_APP_PING_URL", "https://my.efocs.app/ping");

export function getEndpointConfig(userType: number): EndpointConfig {
  return userType === 1 ? endpointConfig.production : endpointConfig.sandbox;
}

export function buildSseUrl(userType: number, userId: string | number, userKey: string): string {
  const url = new URL(getEndpointConfig(userType).sseBaseUrl);
  url.searchParams.set("vn", "100");
  url.searchParams.set("os", "b");
  url.searchParams.set("id", String(userId));
  url.searchParams.set("key", userKey);
  return url.toString();
}
